import { IconProps, QrCode } from "@phosphor-icons/react";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { PaymentModeType } from "lib/types/payments";
import { classNames } from "lib/utils/helpers";
import { paymentMethodsConfig } from "lib/utils/payments";
import React from "react";

interface LogosStackProps {
  logos: string[];
}

const LogosStack: React.FC<LogosStackProps> = ({ logos }) => {
  return (
    <div className="flex">
      {logos?.map((logo, index) => {
        return (
          <div
            key={logo}
            className={classNames("relative", index > 0 ? "-ml-2" : "")}
            style={{ zIndex: logos.length - index }}>
            <img src={logo} className="w-6 h-6 border-2 border-zinc-400/15 rounded-full" alt="logo" />
          </div>
        );
      })}
    </div>
  );
};

interface MethodLogoProps extends IconProps {
  mode: PaymentModeType;
  className?: string;
}

export const MethodLogo: React.FC<MethodLogoProps> = ({ color, size = 28, mode, className }) => {
  let LOGO: string | React.ComponentType<IconProps> = paymentMethodsConfig[mode]?.logo;
  const {
    state: { merchant },
  } = useMerchantContext();

  if (mode === "UPI" && merchant?.upiTileWithIcons) {
    LOGO = QrCode;
  }

  const altText = paymentMethodsConfig[mode]?.header || `${mode} logo`;

  return (
    <div className="p-0.5">
      {typeof LOGO === "string" ? (
        <img
          src={LOGO}
          alt={altText}
          width={Number(size)}
          height={Number(size)}
          loading="lazy"
          className={classNames("object-contain", className || "")}
        />
      ) : (
        <LOGO size={size} weight="duotone" color={color} className={className} />
      )}
    </div>
  );
};

export default LogosStack;
